// source/assets/utils/index.js
function formDataToJson(formData) {
  const obj = Object.fromEntries(formData);
  const { id, quantity = 1 } = obj;
  if (!id) return null;
  const properties = Object.entries(obj).reduce((properties2, [key, value]) => {
    var matches = key.match(/\[(.*?)\]/);
    if (!key.startsWith("properties") || !matches) return properties2;
    let name = matches[1];
    if (value.length) properties2[name] = value;
    return properties2;
  }, {});
  const primaryItem = {
    id: Number(id),
    quantity: Number(quantity),
    properties
  };
  return {
    items: [primaryItem]
  };
}

// source/assets/components/product-form.js
var ProductForm = class extends globalThis.spx.Component({
  name: "productform",
  // Define an identifier (optional)
  sugar: false,
  // Whether or not to use node sugars (optional)
  merge: false,
  // Whether or not snapshot merging applies (optional)
  nodes: ["variantId", "submit"],
  // Define elements associated with components (optional)
  state: {}
}) {
  connect() {
  }
  onmount() {
  }
  unmount() {
  }
  handleSubmit(event) {
    event.preventDefault();
    const items = formDataToJson(new FormData(event.target));
    console.log("Submit form", items);
  }
};
export {
  ProductForm
};
//# sourceMappingURL=components-product-form.js.map
